module.exports = __webpack_public_path__ + "img/201604-4-1024x1024.b65c4c1d.jpg";